import type { ObjectMetadata } from '@olytic/foundation';

import { OBJECT_DEFS } from '../../objects/objectDefs';
import { createdByField, lastModifiedByField, listColumnsOf, type Row, schemaRecord, text } from './kit';

const def = OBJECT_DEFS.assets;

/**
 * Its fields come from the database (the server's SCHEMA_OBJECTS), shown by
 * their type, the Account, App and Product linked to their records; any column
 * not placed below appears in Other Fields (MOTHER-302). Today every column
 * the record reads is placed, so none shows. Product Code and Active are the
 * list's alone (the record shows the Product, and its dates), so they stay off
 * the page, as before.
 */
const field = schemaRecord('assets', { hidden: ['product_code', 'active'] });

const details = [
  field('name', 'Asset'),
  field('account_name', 'Account'),
  field('project_name', 'App'),
  field('product_name', 'Product'),
  field('billing', 'Billing'),
  field('quantity', 'Quantity'),
  field('unit_price', 'Price'),
  field('start_date', 'Start'),
  field('end_date', 'End'),
  field('notes', 'Notes', { wide: true }),
  field('created_at', 'Created'),
  field('updated_at', 'Last Modified'),
  createdByField(),
  lastModifiedByField(),
];

/** An asset: something an account owns or subscribes to, at the price it pays. Rationale: assets.md. */
export const assets: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Asset',
  plural: def.label,
  icon: def.icon,
  listColumns: listColumnsOf(def, details),
  details,
  sections: [
    { key: 'identity', fields: ['name', 'account_name', 'project_name', 'product_name', 'billing', 'quantity', 'unit_price', 'start_date', 'end_date'] },
    { key: 'notes', label: 'Notes', fields: ['notes'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'account_name', 'project_name'],
};
